import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { fetchFaqs } from "@/lib/api";
import FaqAccordion from "@/components/FaqAccordion";
import { Reveal } from "@/components/Reveal";

export default function FaqPage() {
  const { data, isLoading } = useQuery({ queryKey: ["faqs"], queryFn: fetchFaqs });
  const faqs = data?.data ?? [];
  const cats = ["همه", ...new Set(faqs.map((f) => f.category))];
  const [cat, setCat] = useState("همه");
  const [q, setQ] = useState("");

  const filtered = faqs.filter(
    (f) =>
      (cat === "همه" || f.category === cat) &&
      (q.trim() === "" || f.q.includes(q.trim()) || f.a.includes(q.trim())),
  );

  return (
    <section className="mx-auto max-w-3xl px-5 pb-24 pt-36" data-testid="faq-page">
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-gold">
          <span className="h-px w-8 bg-gold/60" />سوالات متداول<span className="h-px w-8 bg-gold/60" />
        </span>
        <h1 className="text-3xl font-black sm:text-4xl">پاسخ شفاف به همه <span className="gold-text">ابهام‌ها</span></h1>
        <p className="max-w-lg text-sm leading-8 text-slate-400">هر سوالی دارید — حقوقی، مالی یا مدارک — اول اینجا جستجو کنید؛ پاسخ کافی نبود، مشاوره رایگان بگیرید.</p>
      </div>

      <Reveal className="mt-10">
        <div className="relative">
          <Search size={17} className="absolute right-5 top-1/2 -translate-y-1/2 text-gold/70" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="جستجو در سوالات متداول..."
            className="w-full rounded-full border border-gold/25 bg-navy-850/80 py-4 pl-5 pr-12 text-sm text-slate-100 outline-none transition-colors placeholder:text-slate-500 focus:border-gold/60"
            data-testid="faq-search-input"
          />
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`rounded-full px-4 py-1.5 font-display text-xs font-bold transition-all duration-300 ${cat === c ? "bg-gold text-navy-950" : "border border-gold/25 text-slate-300 hover:border-gold/60"}`} data-testid={`faq-filter-${c}`}>
              {c}
            </button>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.1} className="mt-10">
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-3xl bg-navy-850/50" />
        ) : filtered.length > 0 ? (
          <FaqAccordion items={filtered} testPrefix="faq" />
        ) : (
          <p className="py-14 text-center text-slate-500" data-testid="faq-empty-state">سوالی با این عبارت پیدا نشد؛ عبارت دیگری امتحان کنید یا مستقیم با ما تماس بگیرید.</p>
        )}
      </Reveal>
    </section>
  );
}
